const inicialState = {
  errata: {},
  selectErrata: false,  
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/erratas/erratas.state.js